import type { Product } from '@commerce/types'
import cn from 'clsx'
import Image from 'next/image'
import { FC } from 'react'
import PlaceholderImg from '../../../../site/public/product-img-placeholder.png'

const missingBrands = [
  'aura',
  'axis',
  'bohemia',
  'chelsea_rose',
  'isadora',
  'mr_wolf_watches',
  'nikki_lissoni',
  'palas',
  'pastiche',
  'paul_hewitt',
  'philip_watches',
  'roamer',
  'sunrise_accessories',
  'hoskings',
]
interface Props {
  product: Product.Product
}

const findTagValueByName = (tags: string[] | undefined, name: string) => {
  if (!tags?.length) return null

  const foundTag = tags.find((tag) => {
    return tag.split(':')?.[0] === name
  })

  return foundTag ? foundTag.split(':')?.[1] : null
}

const mapBrandFilePath = (brand: string) => {
  const ext = ['willow_tree', 'disney_traditions'].includes(brand)
    ? 'jpg'
    : 'svg'
  let mappedBrand = brand
  if (brand === 'peter_w_beck') {
    mappedBrand = 'becks'
  } else if (brand === 'fossil_jewellery') {
    mappedBrand = 'fossil'
  }

  return `/assets/brand_logos/Brand_${mappedBrand}.${ext}`
}

const ProductTags: FC<Props> = ({ product }) => {
  const tags: string[] | undefined = product?.tags

  const images = []

  const brand = findTagValueByName(tags, 'Brand')
  if (brand) {
    if (!missingBrands.includes(brand)) {
      images.push({
        url: mapBrandFilePath(brand),
        alt: brand,
        border: false,
        greyBG: true,
        width: 171,
        height: 72,
        shrink: true,
      })
    }
  }

  const warranty = findTagValueByName(tags, 'Warranty')
  if (warranty) {
    images.push({
      url: `/assets/warranty_logos/${warranty}_logo.svg`,
      alt: brand,
      border: false,
      greyBG: true,
      width: 171,
      height: 72,
      shrink: false,
    })
  }

  if (brand && brand != 'hoskings') {
    images.push({
      url: `/assets/authorised_retailer_logo.svg`,
      alt: brand,
      border: false,
      greyBG: true,
      width: 171,
      height: 72,
      shrink: false,
    })
  }

  const wr = findTagValueByName(tags, 'water_resistance')
  if (wr) {
    images.push({
      url: `/assets/water_resistance_logos/wr_${wr}_logo.svg`,
      alt: brand,
      border: false,
      greyBG: false,
      width: 72,
      height: 72,
      shrink: false,
    })
  }

  if (images.length === 0) return null

  return (
    <div className="flex items-center mt-8 overflow-hidden h-20 justify-center md:justify-start">
      {images?.map((tag, k) => (
        <div
          key={k}
          className={cn('h-full flex justify-center items-center', {
            'ml-4': k !== 0,
            'border-[0.5px]': tag.border,
            'border-[#464644]': tag.border,
            'bg-brand-polar-white': tag.greyBG,
          })}
        >
          <Image
            src={tag.url}
            alt={tag.alt!}
            width={tag.width}
            height={tag.height}
            placeholder="blur"
            blurDataURL={PlaceholderImg.blurDataURL}
            className={cn({ 'max-w-[80%] max-h-[80%]': tag.shrink })}
          />
        </div>
      ))}
    </div>
  )
}

export default ProductTags
